import React, { useEffect, useState } from "react";
import "./QwikCategories.css";
import { Button, Card, Col, Divider, Modal, Row, Spin, Typography } from "antd";
import Lottie from "lottie-react";
import { ReactComponent as QwickLogo } from "../../../assets/icons/Qwik-logo.svg";
import { ReactComponent as TruckActive } from "../../../assets/icons/truckActiveImg.svg";
import { ReactComponent as TruckInactive } from "../../../assets/icons/truckInactiveImg.svg";
import {
  ArrowLeftOutlined,
  CheckOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router";
import {
  useLazyGetQwikConfigQuery,
  useUpdateQwikConfigMutation,
} from "../../../apis/dashboard";

const { Text, Title } = Typography;

// Place your truck animation JSON files in src/assets/animation/
// e.g. truck-active.json and truck-inactive.json
let truckActiveAnim = null;
let truckInactiveAnim = null;
try { truckActiveAnim = require("../../../assets/animation/truck-active.json"); } catch (e) {}




const QwikCategories = () => {
  const navigate = useNavigate();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [getQwikConfig, { data: qwikConfig, isFetching }] =
    useLazyGetQwikConfigQuery();

  const [updateQwikConfig, { isLoading: isUpdating }] =
    useUpdateQwikConfigMutation();

  useEffect(() => {
    getQwikConfig();
    // eslint-disable-next-line
  }, []);

  const isDeliveryActive = qwikConfig?.data?.enable_quick_commerce;
  console.log("🚀 ~ QwikCategories ~ isDeliveryActive:", isDeliveryActive)
  const cityName = qwikConfig?.data?.city_name || "Bengaluru";
  const timeSlot = qwikConfig?.data?.time_slot || "Everyday: 10:00am - 05:00pm";
  const activeUntil = qwikConfig?.data?.inactive_until || "";
  const nextActiveOn = qwikConfig?.data?.next_active_on || "";

  const handleStopStartClick = () => {
    setShowConfirmModal(true);
  };

  const handleConfirm = async () => {
    try {
      await updateQwikConfig({
        enable_quick_commerce: !isDeliveryActive,
      }).unwrap();
      setShowConfirmModal(false);
      getQwikConfig(); // refresh config after update
    } catch (err) {
      console.error("Failed to update QWIK config:", err);
    }
  };

  const handleCancelModal = () => {
    setShowConfirmModal(false);
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Col className="qwik-categories-wrapper">
      {/* Back Button */}
      <Button
        type="default"
        icon={<ArrowLeftOutlined />}
        className="qwik-back-btn"
        onClick={handleBack}
      >
        BACK
      </Button>

      {/* Status Card */}
      <Card className="qwik-status-card" bordered={false}>
        <Spin spinning={isFetching}>
        {/* Card Header: City name + Time slot */}
        <Row justify="space-between" align="middle" className="qwik-card-header">
          <Title level={3} className="qwik-city-name">
            {cityName}
          </Title>
          <Text className="qwik-time-slot">
            <ClockCircleOutlined className="qwik-clock-icon" />
            {timeSlot}
          </Text>
        </Row>

        {/* Card Body */}
        <Col className="qwik-card-body">
          {/* QWIK Flame Logo */}
          <Col className="qwik-logo-wrapper">
            <QwickLogo className="qwik-flame-logo" />
            
          </Col>

          {/* Delivery Status Badge */}
          {isDeliveryActive ? (
            <Col className="qwik-active-badge">
              <span className="qwik-active-dot" />
              <Text className="qwik-active-text">Delivery active</Text>
            </Col>
          ) : (
            <Col className="qwik-inactive-badge">
              <span className="qwik-inactive-dot" />
              <Text className="qwik-inactive-text">Delivery inactive</Text>
            </Col>
          )}

          {/* Description */}
          <Text className="qwik-delivery-desc">
            {isDeliveryActive
              ? `Users can place the orders. Will be automatically inactive on ${activeUntil}`
              : `Users cannot place the orders. Will be automatically active on ${nextActiveOn}`}
          </Text>

          {/* Truck Illustration */}
          <Col className="qwik-truck-wrapper">
            {isDeliveryActive ? (
              truckActiveAnim ? (
                <Lottie
                  animationData={truckActiveAnim}
                  loop
                  autoplay
                  className="qwik-truck-lottie"
                />
              ) : (
                <TruckActive className="qwik-truck-img" />
              )
            ) : (
              truckInactiveAnim ? (
                <Lottie
                  animationData={truckInactiveAnim}
                  loop
                  autoplay
                  className="qwik-truck-lottie"
                />
              ) : (
                <TruckInactive className="qwik-truck-img" />
              )
            )}
          </Col>

          {/* Dashed Divider */}
          <Divider dashed className="qwik-divider" />

          {/* Stop / Start QWIK Button */}
          {isDeliveryActive ? (
            <Button
              icon={<CloseCircleOutlined />}
              className="qwik-stop-btn"
              onClick={handleStopStartClick}
            >
              Stop QWIK
            </Button>
          ) : (
            <Button
              icon={<CheckOutlined />}
              className="qwik-start-btn"
              onClick={handleStopStartClick}
            >
              Start QWIK
            </Button>
          )}
        </Col>
        </Spin>
      </Card>

      {/* Confirmation Modal */}
      <Modal
        open={showConfirmModal}
        onCancel={handleCancelModal}
        footer={null}
        centered
        closable
        closeIcon={<CloseOutlined />}
        width={400}
        className="qwik-confirm-modal"
      >
        <Col className="qwik-modal-body">
          <Title level={4} className="qwik-modal-title">
            Are you sure?
          </Title>
          <Text className="qwik-modal-desc">
            {isDeliveryActive
              ? `Users will not be able to place QWIK orders. QWIK will be automatically active on ${nextActiveOn}`
              : `Users will be able to place QWIK orders. QWIK will be automatically inactive on ${activeUntil}`}
          </Text>
          <Row justify="center" gap={12} className="qwik-modal-actions">
            <Button
              className="qwik-modal-cancel-btn"
              onClick={handleCancelModal}
            >
              Cancel
            </Button>
            <Button
              className={isDeliveryActive ? "qwik-modal-confirm-stop-btn" : "qwik-modal-confirm-start-btn"}
              loading={isUpdating}
              onClick={handleConfirm}
            >
              {isDeliveryActive ? "Yes, stop QWIK" : "Yes, start QWIK"}
            </Button>
          </Row>
        </Col>
      </Modal>
    </Col>
  );
};

export default QwikCategories;
